import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BigIconFlexButtonWrapper from "~/cabinet/vue/interface/button/BigIconFlexButtonWrapper.vue";
import SideMenuCard from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCard.vue";


const __default__ = {
    name: "SideMenuBigFlexButtons"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    withShadow: { type: Boolean }
  },
  setup(__props: any) {

let props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SideMenuCard, {
    class: _normalizeClass({
            'buttons position-relative': true,
            'with-shadow': __props.withShadow
        }),
    margin: false,
    "without-padding": ""
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "before"),
      _createVNode(BigIconFlexButtonWrapper, { margin: false }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})